import { Identifiers, Properties } from "../../../core/internal/model/model"
import ObjectUtil from "../../../core/internal/util/ObjectUtil"
import { PropertiesBuilder } from "../../property/PropertiesBuilder"
import { InAppMessageScheduleRequest } from "../schedule/InAppMessageScheduleRequest"

export class InAppMessageDeliverRequest {
  constructor(
    public readonly dispatchId: string,
    public readonly inAppMessageKey: number,
    public readonly identifiers: Identifiers,
    public readonly requestedAt: number,
    public readonly reason: string,
    public readonly properties: Properties
  ) {}

  static of(request: InAppMessageScheduleRequest): InAppMessageDeliverRequest {
    const builder = new PropertiesBuilder()
    const properties = builder.add("$trigger_event_insert_id", request.schedule.eventBasedContext.insertId).build()

    return new InAppMessageDeliverRequest(
      request.schedule.dispatchId,
      request.schedule.inAppMessageKey,
      request.schedule.identifiers,
      request.requestedAt,
      request.schedule.reason,
      ObjectUtil.fromMap(properties)
    )
  }

  toString(): string {
    return `InAppMessageDeliverRequest(dispatchId=${this.dispatchId}, inAppMessageKey=${this.inAppMessageKey}, identifiers=${this.identifiers}, requestedAt=${this.requestedAt}, reason=${this.reason}`
  }
}
